import axios from "./configs/axiosConfig";

export const getAgreementList = async (dealerId) => {
  const url = `agreements/dealer/${dealerId}`;
  return await axios.get(url);
};

export const getAgreementEquipmentsList = async (agreementId) => {
  const url = `agreements/${agreementId}/equipments`;
  return await axios.get(url);
};

export const getAgreementDetails = async (agreementId) => {
  const url = `agreements/${agreementId}/agreementdetails`;
  return await axios.get(url);
};

export const createDupilcateAgreement = async (
  agreementId,
  agreementDetails
) => {
  const url = `agreements/${agreementId}/duplicateagreement`;
  return await axios.post(url, agreementDetails);
};

export const addAgreementEquipments = async (
  agreementId,
  equipmentList,
  optype
) => {
  const url = `agreements/${agreementId}/equipments?optype=${optype}`;
  return await axios.post(url, equipmentList);
};
// override asks the submit Lambda to accept equipment conflicts (ADO #334); it honours that only
// for an admin, by the authorizer's claims, so a dealer sending it is refused all the same.
export const submitAgreementEquipments = async (agreementId, override = false) => {
  const url = `agreements/${agreementId}/equipmentsync${override ? "?override=1" : ""}`;
  return await axios.put(url);
};

export const searchInvoice = async (dealerId, searchType, searchKey,tenantId) => {
  const url = `agreements/dealer/${dealerId}/invoicesearch?searchType=${searchType}&searchKey=${searchKey}&tenantid=${tenantId}`;
  return await axios.get(url);
};

export const createAgreementFromInvoice = async (dealerId, data) => {
  const url = `agreements/dealer/${dealerId}/newinvoiceagreement`;
  return await axios.post(url, data);
};

export const getStEquipmentsForTenant = async (dealerId, data) => {
  const url = `agreements/dealer/${dealerId}/stequipments?data=${data}`;
  return await axios.get(url);
};

export const deleteAgreementEquipments = async (agreementId, userName) => {
  const url = `agreements/${agreementId}/equipments?deleteby=${userName}`;
  return await axios.patch(url);
};


export const updateAgreementInfo = async (agreementId,info) => {
  const url = `agreements/${agreementId}/updateinfo`;
  return await axios.patch(url,info);
};

export const fetchAgreementFromJBById = async (agreementId) => {
  const url = `agreements/jbw/${agreementId}`;
  return await axios.get(url);
};

// Same endpoint, keyed on the JBW agreement number instead of tblAgreement.id. The
// Agreement Sync grid rows come from vwagreementmatchdata, which does not carry the agreement
// row id, so the location-mapping dialog has no other way to ask for an agreement's equipment.
// `ownerTenantId` is optional and only differs on a cross-tenant move: tenantId scopes the
// ServiceTitan credentials and the location being read, ownerTenantId names the tenant the
// agreement row still lives in. Omitted means "the same tenant for both", which is every other
// caller. Without it, asking the TARGET location for its candidate units resolves the agreement
// in the target tenant -- where it does not exist yet -- and 404s on every cross-tenant move.
export const getStInstalledEquipmentsByJbwAgreementId = async (jbwAgreementId, tenantId, locationId, ownerTenantId) => {
  const owner = ownerTenantId ? `&ownerTenantId=${ownerTenantId}` : "";
  const url = `agreements/${jbwAgreementId}/getstinstalledequipment?tenantId=${tenantId}&locationId=${locationId}&invoiceId=&idType=jbw${owner}`;
  return await axios.get(url);
};

// idType is optional and appended only when set, so the three callers that hold a real
// tblAgreement.id produce a byte-identical URL. The New Agreement dialog passes "invoice": the id
// it holds is a tblInvoice.id and no agreement exists yet -- creating one is the point of that
// screen -- so the handler must not try to resolve one.
export const getStInstalledEquipments = async (agreementId,tenantId,locationId,invoiceId,idType) => {
  const type = idType ? `&idType=${idType}` : "";
  const url = `agreements/${agreementId}/getstinstalledequipment?tenantId=${tenantId}&locationId=${locationId}&invoiceId=${invoiceId}${type}`;
  return await axios.get(url);
}

/**
 * Fetch locations from ST system based on address search
 * @param {Object} address - { addressLine1, addressLine2, city, state, zipcode }
 * @param {number|string} tenantId
 */
export const fetchSTLocationsByAddress = async (address, tenantId) => {
  try {
    const params = {
      tenantId: tenantId,
      street: address.addressLine1,
      unit: address.unit,
      city: address.city,
      state: address.state,
      zip: address.zipcode,
      customerId: address.customerId,
    };

    const res = await axios.get("/stlocations/search/tenant", { params });

    return res.data;
  } catch (err) {
    console.error("Failed to fetch ST locations by address", err);
    return [];
  }
};